"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const DATE_FORMAT = "dd.MM";
const PRECISE_DATE_FORMAT = `${DATE_FORMAT}. yyyy`;
const formatDate = (date, precise) => (date_fns_1.format(date, precise ? PRECISE_DATE_FORMAT : DATE_FORMAT));
exports.default = formatDate;
